import JSONAPISerializer from '@ember-data/serializer/json-api';

export default class MessageSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return attr;
  }

  serialize() {
    let json = super.serialize(...arguments);

    if (json.data?.attributes?.loading !== undefined) {
      delete json.data.attributes.loading;
    }
    return json;
  }
}
